<div class="themed-dialog tutor-dialog">
  <h2 mat-dialog-title class="themed-dialog__title" tabindex="0">{{ 'user.tutors.title' | translate }}</h2>
  <div mat-dialog-content>
    <app-tutors-form
      [showReminder]="true"
      [showDescription]="true"
      (submitted)="onSubmit($event)"
      (dismissed)="onDismiss($event)">
      <p class="tutor-dialog__text" tabindex="0">{{ 'user.tutors.description' | translate }}</p>
    </app-tutors-form>
  </div>
</div>
